<template>
  <div :id="id" class="open-sea-dragon"></div>
</template>

<script>
/* eslint-disable no-console */

import OpenSeadragon from "openseadragon";

export default {
  props: {
    id: {
      type: String,
      default: "openseadragon-viewer"
    },
    prefixUrl: {
      type: String,
      default: "~openseadragon/build/openseadragon/images/"
    },
    zoom: {
      type: Number,
      default: 1
    },
    maxZoomLevel: {
      type: Number
    },
    ajaxWithCredentials: {
      type: Boolean
    },
    showNavigator: {
      type: Boolean,
      default: true
    },
    homeFillsViewer: {
      type: Boolean
    },
    navigatorId: {
      type: String
    },
    toolbar: {
      type: String
    },
    zoomInButton: {
      type: String
    },
    zoomOutButton: {
      type: String
    },
    homeButton: {
      type: String
    },
    fullPageButton: {
      type: String
    },
    panHorizontal: {
      type: Boolean,
      default: true
    },
    panVertical: {
      type: Boolean,
      default: true
    },
    mouseNavEnabled: {
      type: Boolean,
      default: true
    },
    tileSources: {
      type: String,
      default: ""
    },
    rotateDeg: {
      type: Number,
      default: 0
    }
  },
  components: {},
  data() {
    return {
      viewer: undefined
    };
  },
  computed: {
    seaDragonSettings() {
      return Object.assign(
        {
          id: this.id,
          tileSources: this.tileSources,
          prefixUrl: this.prefixUrl,
          ajaxWithCredentials: this.ajaxWithCredentials,
          showNavigator: this.showNavigator,
          homeFillsViewer: this.homeFillsViewer,
          panHorizontal: this.panHorizontal,
          panVertical: this.panVertical,
          mouseNavEnabled: this.mouseNavEnabled,
          showZoomControl: false,
          showHomeControl: false,
          showFullPageControl: false
        },
        {
          maxZoomLevel: this.maxZoomLevel,
          navigatorId: this.navigatorId,
          toolbar: this.toolbar,
          zoomInButton: this.zoomInButton,
          zoomOutButton: this.zoomOutButton,
          homeButton: this.homeButton,
          fullPageButton: this.fullPageButton
        }
      );
    }
  },
  mounted() {
    this.viewer = OpenSeadragon(this.seaDragonSettings);
  },
  watch: {
    tileSources: function(newVal, oldVal) {
      console.info(newVal)
      if (newVal !== oldVal) {
        this.viewer.open(newVal);
      }
    },
    rotateDeg(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.viewer.viewport.setRotation(newVal);
      }
    }
  }
};
</script>

<style scoped>
.open-sea-dragon {
  width: 100%;
  height: calc(100vh - 200px);
  overflow: hidden;
}
</style>
